__turbopack_context__.v({
  "className": "modernist_a5d9f9a1-module__WrkLAG__className",
  "variable": "modernist_a5d9f9a1-module__WrkLAG__variable",
});
